<template>
  <div class="form-block">
      <div class="header relative">
          <div class="line absolute"></div>
          <div class="clear_a title_box">
            <div class="title">{{title}}</div>
            <div class="toggle-btn" v-if='zoomed'  @click="show = !show">
                {{show?'展开':'收起'}}
                <span :class="show?'el-icon-arrow-down':'el-icon-arrow-up'"></span>
            </div>
          </div>
          
      </div>
      <!--<transition name="slide-fade">-->
        <el-collapse-transition>
            <div v-show="show">
                <slot ></slot>
            </div>
        </el-collapse-transition>
        
      <!--</transition>-->
  </div>
</template>

<script>
export default {
  name:'ToggleForm',
  props:{
      title:{
          type:String
      },
      zoomed:{
          type:Boolean,
          default:true
      }
  },
  data(){
      return {
          show:true,
      }
  }
}
</script>

<style scoped lang='scss'>
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier();
}
.slide-fade-enter, .slide-fade-leave-active {
  opacity: 0;
}

.form-block{
    background: #fff;
    box-shadow:0px 2px 4px 0px rgba(221,221,221,0.5);
    border-radius:4px;
    margin-bottom: 20px;
    padding-bottom: 20px;
}
.form-block .header{
    padding:0 30px;
    width: calc(100% - 60px);
    height:55px;
    line-height: 55px;
    .line{
        width:6px;
        height:20px;
        background:rgba(112,206,151,1);
        left: 0;
        top: 18px;
    }
    .title_box{
        border-bottom: 1px solid #eee;
        line-height: 55px;
    }
}

.form-block .header .title_box>div{
   box-sizing: border-box;
   height: 55px;
   line-height: 55px;
   color: #333;
}
.form-block .header .title_box .title{
    width: calc(100% - 60px);
    margin-right: 2px;
    font-size: 16px;
    text-align: left;
}
.form-block .header .title_box .toggle-btn{
    width: 58px;
    font-size: 14px;
    text-align: left;
    cursor: pointer;
    position: relative;
    span{
        position: absolute;
        right: 0px;
        top: 20px;
    }
}
</style>

<style>
/* 改变多选框组的样式 */
.form-block .el-checkbox-group{
    display: inline-block;
    width: 280px;
    vertical-align: top;
}
.form-block .el-checkbox+.el-checkbox{
	margin:0;
}
.form-block .el-checkbox{
    margin: 0;
}
.form-block .el-checkbox-group .el-checkbox{
    margin:0 15px 10px 0;
}

</style>


